import React from "react";
import styled from "styled-components";

import CustomerQuote from "components/shared/CustomerQuote";
import timKramerLogo from "assets/home/logo-tim-kramer-photography.webp";

export default function QuoteSection() {
  return (
    <Wrapper>
      <Content>
        <CustomerQuote
          author="Tim @ Tim Kramer Photography"
          quote="I use PI every single day, literally. Love it to death."
          logo={timKramerLogo}
        />
      </Content>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 50px 0 30px;

  @media (max-width: 700px) {
    padding: 20px;
  }
`;

const Content = styled.div`
  width: 1000px;
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;

  @media (max-width: 930px) {
    flex-direction: column;
    width: 700px;
  }
`;
